import React, { FC } from 'react';

import { cn, ClassName } from '../../utils';
import styles from './index.module.scss';


export type CheckboxProps = ClassName & {
    name?: string;
    checked: boolean;
    markClassName?: string;
    disabled?: boolean;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    readOnly?: boolean;
}

export const Checkbox: FC<CheckboxProps> = ({
    children,
    className,
    markClassName,
    disabled,
    onClick, readOnly,
    ...inputProps
}) => (
    <label
        className={cn(
            styles.checkbox,
            disabled && styles.disabled,
            className,
        )}
        onClick={disabled ? undefined : onClick}
    >
        <input type='checkbox' {...inputProps} disabled={disabled || readOnly} />
        <span className={cn(styles.mark, markClassName)} />
        {children && (
            <span className={styles.label}>
                {children}
            </span>
        )}
    </label>
);
